<template>
  <b-dropdown v-if="visible" :disabled="!completed" variant="primary"
              :text="$t('navigation.download.label')">
    <b-dropdown-item @click="downloadText(true)">{{$t('text.download.download_options.simple')}}</b-dropdown-item>
    <b-dropdown-item @click="downloadText(false)">{{$t('text.download.download_options.full')}}</b-dropdown-item>
    <b-dropdown-item v-if="document.medium === 'Spoken'" @click="downloadAudio">{{$t('text.download.download_options.audio')}}</b-dropdown-item>
  </b-dropdown>
</template>
<script>
  import map from 'lodash/map'
  import {mapState} from 'vuex'
  import saveAs from 'file-saver'

  export default {
    computed: {
      ...mapState({
        completed: s => s.api.executionState === 'completed',
        resultType: s => s.api.resultType,
        result: s => s.api.result,
      }),
      visible() {
        return this.resultType === 'text' || this.resultType === 'context'
      },
      document() {
        return this.completed && this.result.document // Access result content after request finishes
      },
      text() {
        if (this.resultType === 'text') {
          return this.result.text
        } else if (this.resultType === 'context') {
          return this.result.match.text
        }
      },
      header() {
        return map(this.$ncsConfig.cedel2.sourceFields[this.result.document.subcorpus], f => {
          const value = f !== 'task_title' ? this.result.document[f] : this.result.document[f].replace(/^\d{1,2}\. /, '')
          return `${this.fieldName(f)}: ${this.$ncsConfig.fieldValue(value)}\n`
        })
      },
    },
    methods: {
      fieldName(field) {
        return this.$i18n.t(`result.context.header.document.${field}`)
      },
      downloadText(textOnly) {
        const parts = []
        parts.push(...(textOnly ? '' : this.header))
        parts.push(`${this.$t('result.context.header.text.source_text')}: ${this.text.source_text}\n`)
        parts.push(this.text.original && !textOnly ? `${this.$t('result.context.header.text.original')}: ${this.text.original}` : '')
        saveAs(new Blob(parts, {type: 'text/plain'}), `${this.document.filename}.txt`)
        this.$ga.page(`/search/${this.resultType}/download`)
      },
      downloadAudio() {
        saveAs(`./audio/${this.result.document.filename}.mp3`, `${this.result.document.filename}.mp3`)
        this.$ga.page(`/search/${this.resultType}/download/audio`)
      }
    }
  }
</script>